// import ScrollMagic from 'scrollmagic';
// import { TweenMax, TimelineMax, Linear } from 'gsap';
// import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import lookbookPlayer from './player';
// import '../../../../../node_modules/scrollmagic/scrollmagic/minified/plugins/animation.gsap.min';
// import '../../../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

const initFadeInUp = () => {
  const scrollmagicController = new ScrollMagic.Controller();
  const revealElements = document.querySelectorAll('.fadeInUp');

  revealElements.forEach(revealElement => {
    new ScrollMagic.Scene({
      // y value not modified, so we can use element as trigger as well
      triggerElement: revealElement,
      // start a little later
      offset: -document.querySelector('.main-nav--desktop').offsetHeight,
      triggerHook: 0.8,
      reverse: false,
    })
      // add class toggle
      .setClassToggle(revealElement, 'animated')
      // .addIndicators({name: "Fade " + (i + 1) }) // add indicators (requires plugin)
      .addTo(scrollmagicController);
  });
};

const initParallax = () => {
  const parallax_controller = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 'onEnter',
      duration: '200%',
    },
  });

  document.querySelectorAll('.parallax').forEach(parallax_element => {
    const timeline = new TimelineMax();
    const trig = parallax_element.parentElement;
    const parallax_value = parallax_element.getAttribute('data-parallax');
    const speed = `${Number(parallax_value) * 50}%`;
    const fadeInFrom = TweenMax.from(parallax_element, 1, { autoAlpha: 0 });
    const fadeInTo = TweenMax.to(parallax_element, 0.8, { autoAlpha: 1 });

    timeline.add(fadeInFrom).add(fadeInTo);

    new ScrollMagic.Scene({
      triggerElement: trig,
      offset: -document.querySelector('.main-nav--desktop').offsetHeight,
    })
      .setTween(parallax_element, { y: speed, ease: Linear.easeNone })
      .addTo(parallax_controller);

    new ScrollMagic.Scene({
      triggerElement: trig,
      offset: -document.querySelector('.main-nav--desktop').offsetHeight,
    })
      .setTween(timeline)
      .addTo(parallax_controller);
  });
};

const initParallaxOffset = () => {
  const parallax_controller = new ScrollMagic.Controller(
    {
      globalSceneOptions: {
        triggerHook: 'onEnter',
        duration: '70%',
      },
    },
  );

  document.querySelectorAll('.parallaxoffset').forEach(parallax_element => {
    const timeline = new TimelineMax();
    const trig = parallax_element.parentElement;
    const parallax_value = parallax_element.getAttribute('data-parallax');
    const speed = `${Number(parallax_value) * 1}%`;
    const fadein = TweenMax.from(parallax_element, 1, { opacity: 0 });
    timeline.add(fadein);

    new ScrollMagic.Scene({
      triggerElement: trig,
      offset: -document.querySelector('.main-nav--desktop').offsetHeight,
    })
      .setTween(parallax_element, { y: speed, ease: Linear.easeNone })
      .addTo(parallax_controller);

    new ScrollMagic.Scene({
      triggerElement: trig,
      offset: -document.querySelector('.main-nav--desktop').offsetHeight,
    })
      .setTween(timeline)
      .addTo(parallax_controller);
  });
};

const initParallaxX = () => {
  const parallax_controller = new ScrollMagic.Controller(
    {
      globalSceneOptions: {
        triggerHook: '1',
        duration: '100%',
      },
    },
  );

  document.querySelectorAll('.parallaxX').forEach(parallax_element => {
    const timeline = new TimelineMax();
    const trig = parallax_element.parentElement;
    const parallax_value = parallax_element.getAttribute('data-parallaxX');
    const speed = `${Number(parallax_value) * 1}%`;
    const fadeout = TweenMax.to(parallax_element, 0.1, { alpha: 1 });
    const fadein = TweenMax.from(parallax_element, 0.5, { opacity: 0 });
    timeline.add(fadein).add(fadeout);

    new ScrollMagic.Scene({
      triggerElement: trig,
      offset: -document.querySelector('.main-nav--desktop').offsetHeight,
    })
      .setTween(parallax_element, { y: speed, ease: Linear.easeNone })
      .addTo(parallax_controller);

    new ScrollMagic.Scene({
      triggerElement: trig,
      offset: -document.querySelector('.main-nav--desktop').offsetHeight,
    })
      .setTween(timeline)
      .addTo(parallax_controller);
  });
};

const initPanels = () => {
  const panel_controller = new ScrollMagic.Controller();
  let anim_x = [0, 33, 66];

  if (window.theme.breakpoints.current === 'mobile') {
    anim_x = [0, 0, 0];
  }

  document.querySelectorAll('.panels').forEach(panels_element => {
    const trig = panels_element.parentElement;
    const panel_items = trig.querySelectorAll('.panel');
    const timeline = new TimelineMax();

    if (panel_items.length === 4) {
      // define movement of panels
      panel_items.forEach((panel, i) => {
        // 1st element doesn't have any animation
        if (i > 0) {
          timeline.fromTo(panel, 1, { x: '100%' }, { x: `${anim_x[i - 1]}%`, ease: Linear.easeNone });
        }
      });

      // create scene to pin and link animation
      new ScrollMagic.Scene({
        triggerElement: trig,
        triggerHook: 'onLeave',
        duration: '300%',
        // offset: -document.querySelector('.main-nav--desktop').offsetHeight,
      })
        .setPin(trig)
        .setTween(timeline)
        .addTo(panel_controller);
    }
  });
};

const initScaleY = () => {
  const scaleY_controller = new ScrollMagic.Controller();

  document.querySelectorAll('.scaleY').forEach(scaleY_element => {
    const trig = scaleY_element;
    const tween = TweenMax.to(scaleY_element, 1, { scale: 1.5, opacity: 1, ease: Linear.easeNone });

    // create scene to pin and link animation
    new ScrollMagic.Scene({
      triggerElement: trig,
      triggerHook: 0,
      duration: '100%',
      offset: -document.querySelector('.main-nav--desktop').offsetHeight,
    })
      .setTween(tween)
      .setPin(scaleY_element)
      .addTo(scaleY_controller);
  });
};

const initZoomY = () => {
  const zoomY_controller = new ScrollMagic.Controller();

  document.querySelectorAll('.zoomY').forEach(zoomY_element => {
    const trig = zoomY_element;
    const tween = TweenMax.to(zoomY_element, 1, { scale: 1.8, opacity: 1, ease: Linear.easeNone });

    // create scene to pin and link animation
    new ScrollMagic.Scene({
      triggerElement: trig,
      triggerHook: 0,
      duration: '80%',
      // offset: -document.querySelector('.main-nav--desktop').offsetHeight,
    })
      .setPin(trig)
      .setTween(tween)
      .addTo(zoomY_controller);
  });
};

const initFixed = () => {
  // if (window.theme.breakpoints.current === 'mobile') {
  //   return;
  // }

  const fixed_controller = new ScrollMagic.Controller();

  document.querySelectorAll('.fixedSM').forEach(fixed_element => {
    const trig_class = fixed_element.getAttribute('data-fixed-type');
    // const sm_duration = fixed_element.dataset.duration;

    let header_height = 0;
    if (window.theme.breakpoints.current === 'mobile') {
      // Remove 20px due to the height change from unscroll to scrolled on real mobile devices
      const announcement_bar_mobile = document.querySelector('.announcement-bar--mobile');
      const announcement_height = announcement_bar_mobile ? announcement_bar_mobile.offsetHeight : 0;
      header_height = document.querySelector('.main-nav--mobile').offsetHeight + announcement_height - 20;
    } else {
      const announcement_bar_desktop = document.querySelector('.announcement-bar--desktop');
      const announcement_height = announcement_bar_desktop ? announcement_bar_desktop.offsetHeight : 0;
      header_height = document.querySelector('.shopify-section.header').offsetHeight - announcement_height;
    }

    let sm_duration;
    switch (trig_class) {
      case 'vertical-col-2':
      case 'column-1-of-3':
        sm_duration = '200%';
        break;

      case 'horizontal-img-right-fixed-with-scroll-text':
      case 'horizontal-img-left-fixed-with-scroll-text':
        sm_duration = (window.theme.breakpoints.current === 'mobile')
          ? `${125 - ((header_height / window.innerHeight) * 100)}%`
          : `${150 - ((header_height / window.innerHeight) * 100)}%`;
        break;

      // Stays fixed on top but scrolls together with the right image after the text disappears
      case 'img-col-2':
        sm_duration = (window.theme.breakpoints.current === 'mobile') ? '25%' : '50%';

        if (fixed_element.classList.contains('center-image-scroll')) {
          sm_duration = (window.theme.breakpoints.current === 'mobile')
            ? `${75 - ((header_height / window.innerHeight) * 100)}%`
            : `${85 - ((header_height / window.innerHeight) * 100)}%`;
        }
        break;

      case 'lg-img-fixed':
        sm_duration = `${100 - ((header_height / window.innerHeight) * 100)}%`;
        break;

      case 'horizontal-img-right':
      case 'horizontal-img-left':
      case 'right-img-fixed':
      case 'left-img-fixed':
      case 'vertical-col-1':
      case 'column-2-of-3':
        sm_duration = (window.theme.breakpoints.current === 'mobile') ? '150%' : '100%';
        break;

      default:
        sm_duration = window.innerHeight;
    }

    let push_followers = false;
    if (fixed_element.classList.contains('fixed-text')) {
      push_followers = true;
    }

    if (
      fixed_element.classList.contains('fixed-text') &&
      fixed_element.parentElement.getAttribute('data-block-type') === 'full_image_v2'
    ) {
      sm_duration = `${100 - ((header_height / window.innerHeight) * 100)}%`;
      push_followers = false;
      // exclude_nav = header_height / window.innerHeight;
    }

    let exclude_nav = 0;
    if (fixed_element.classList.contains('fixed-text')) {
      exclude_nav = 0;
    } else {
      if (fixed_element.classList.contains('center-image-scroll')) {
        header_height += (window.innerHeight - header_height - fixed_element.offsetHeight) / 2;
      }
      exclude_nav = header_height / window.innerHeight;
    }

    const scene_options = {
      triggerElement: fixed_element,
      duration: sm_duration,
      triggerHook: exclude_nav,
      reverse: true,
    };

    new ScrollMagic.Scene(scene_options)
      .setPin(fixed_element, { pushFollowers: push_followers })
      .addTo(fixed_controller);
  });
};

export default () => {
  // ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
  
  // Scrollmagic animations
  initFadeInUp();
  initParallax();
  initParallaxOffset();
  initParallaxX();
  initScaleY();
  initZoomY();
  initFixed();

  // if (window.theme.breakpoints.current !== 'mobile') {
    initPanels();
  // }

  // Video player
  lookbookPlayer();
};
